import { GetEventCTAPageInfoFragment } from '@graphql/generated';

export const getFindFormVisibility = (
  welcomePage: Maybe<GetEventCTAPageInfoFragment>,
  schedulePage: Maybe<GetEventCTAPageInfoFragment>,
  hasUnlocked: boolean,
  passwordProtectedPagesLength: number,
  rsvpIsPasswordProtected: Maybe<boolean>,
  scheduleHasInviteOnlyItems: Maybe<boolean>,
  rsvpIsEnabled: boolean,
  guestName: string
): boolean => {
  const isUnlocked = hasUnlocked && guestName.length === 0;
  const isAnyPagePasswordProtected = passwordProtectedPagesLength > 0;
  const showFindInvite = rsvpIsEnabled && hasUnlocked;

  // Welcome page is hidden but RSVP varies
  if (welcomePage?.disabled) {
    return isAnyPagePasswordProtected ? showFindInvite : hasUnlocked;
  }

  // Welcome page is public and Schedule page is hidden
  if (schedulePage?.disabled) {
    return isAnyPagePasswordProtected ? showFindInvite : !rsvpIsPasswordProtected || isUnlocked;
  }

  // Welcome page is public and Schedule page is password protected or public with private events
  if (scheduleHasInviteOnlyItems) {
    return isUnlocked;
  }

  // Welcome page is public and Schedule page is password protected
  if (schedulePage?.private) {
    return !rsvpIsEnabled || rsvpIsPasswordProtected ? false : isUnlocked;
  }

  // Welcome page is public and Schedule page is public
  if (isAnyPagePasswordProtected) {
    return showFindInvite;
  }

  return rsvpIsPasswordProtected ? isUnlocked : true;
};
